module.exports = __webpack_public_path__ + "img/CrediYa-Fondo--Creditos.99e57ed0.png";